// Strip the "User#" prefix from a content-addressed contract key for a compact,
// debug-only display. Returns "" for a falsy/malformed key so the caller renders
// nothing. The full key (with prefix) is what click-to-copy puts on the clipboard.
export function keyHash(fullKey) {
  if (!fullKey || typeof fullKey !== "string") return "";
  return fullKey.startsWith("User#") ? fullKey.slice(5) : fullKey;
}
